module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Regular.f62361b4.ttf";